module.exports = __webpack_public_path__ + "static/media/pitch-mock-5.e8416f79.png";